import React from 'react';
import { Button } from '@headlessui/react';

interface SubmitButtonProps {
  label: string;
  disabled?: boolean;
  isSubmitting?: boolean;
  colorScheme?: 'blue' | 'green' | 'indigo' | 'purple';
  className?: string;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  label,
  disabled = false,
  isSubmitting = false,
  colorScheme = 'blue',
  className,
}) => {
  const colorClasses = {
    blue: 'from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:ring-blue-500',
    green: 'from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 focus:ring-green-500',
    indigo: 'from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 focus:ring-indigo-500',
    purple: 'from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 focus:ring-purple-500',
  };

  return (
    <div className={`flex justify-center pt-4 ${className || ''}`}>
      <Button
        type="submit"
        disabled={disabled || isSubmitting}
        className={`group relative inline-flex items-center justify-center gap-3 rounded-xl bg-gradient-to-r ${colorClasses[colorScheme]} py-4 px-12 text-lg font-semibold text-white shadow-xl hover:shadow-2xl focus:outline-none focus:ring-4 focus:ring-offset-2 transition-all duration-200 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none`}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        {isSubmitting ? 'Submitting...' : label}
        <svg
          className="w-5 h-5 transition-transform group-hover:translate-x-1"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
        </svg>
      </Button>
    </div>
  );
};

export default SubmitButton;
